var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.tasks.length &&
      _vm.report.status_raw === 'hin_assignment_started' &&
      _vm.$store.getters.isContractor
    )?_c('div',{staticClass:"flex w-full mb-16 justify-end"},[_c('mi-button',{attrs:{"options":{
        disabled: !_vm.tasksCompleted,
        label: 'Werkzaamheden gereed',
        icon: 'mdi-check',
        class: 'uppercase font-semibold',
        color: 'success',
        round: true,
        flat: true,
      }},nativeOn:{"click":function($event){return _vm.changeStatus('hin_assignment_completed')}}})],1):_vm._e(),_c('TaskList',{attrs:{"tasks":_vm.tasks,"totalPrice":_vm.priceTotal,"canEdit":_vm.report.status_raw === 'hin_assignment_started' &&
      _vm.$store.getters.isContractor},on:{"update:tasks":function($event){_vm.tasks=$event},"taskUpdated":_vm.handleTaskUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }